import React, { lazy } from "react";
import { Magnolia } from "domain/Magnolia";
import { getAlbisCategories } from "services/InteractiveHelpers";

const Section = lazy(() => import("components/common/Section"));
const AlbisInteractiveBuilding = lazy(
  () => import("components/common/Markets/Graphics/AlbisInteractiveBuilding")
);

export interface MagnoliaStudy {
  image: Magnolia.Image;
  link: Magnolia.Link;
  description: Magnolia.RichText;
  shortTitle: Magnolia.Text;
  title: Magnolia.Text;
  tag: Magnolia.Text;
  "@nodes": string[];
}

export interface MagnoliaInteractiveGraphicAlbis extends Magnolia.Component {
  title: Magnolia.Text;
  multisite: Magnolia.MultisiteId;
  description: Magnolia.Text;
}

export interface MagnoliaALBISCategory {
  title: Magnolia.Text;
  text: Magnolia.RichText;
  id: Magnolia.Text;
}
export interface MagnoliaAlbisBrandProps extends Magnolia.Component {
  title: Magnolia.Text;
  image: Magnolia.Image;
  text?: Magnolia.Text;
  link?: Magnolia.Link;
}

const MagnoliaInteractiveBuildingAlbis = ({
  title,
  multisite,
  description,
  ...props
}: MagnoliaInteractiveGraphicAlbis) => {
  // get categories displayed in the interactive image
  const categories = getAlbisCategories(props);

  return (
    <Section>
      <AlbisInteractiveBuilding
        description={description}
        title={title}
        categories={categories}
      />
    </Section>
  );
};

export default MagnoliaInteractiveBuildingAlbis;
